<template>
    <BCard no-body>
      <BCardHeader class="pb-50"> <h5> {{ $t('Filters') }} </h5> </BCardHeader>
      <BCardBody>
        <BRow>
          <BCol cols="12" md="6" class="mb-md-0 mb-2" >
            <label>{{ $t('Status') }}</label>
            <vSelect v-model="statusFilter" :options="status" class="w-100" :reduce="val => val.value"/>
          </BCol>
          <BCol v-if="groups && groups.length>1" cols="12" md="6" class="mb-md-0 mb-2" >
            <label>{{ $t('Group') }}</label>
            <vSelect v-model="groupFilter" :options="groups" label="name" class="w-100" :reduce="val => val.id" />
          </BCol>
        </BRow>
      </BCardBody>
    </BCard>
  </template>
  
  <script>
  import { inject } from '@vue/composition-api'
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  
  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
    setup(){
      const statusFilter = inject('statusFilter')
      const groupFilter = inject('groupFilter')
      const status = inject('status')
      const groups = inject('groups')

      return {
        statusFilter,
        groupFilter,
        status,
        groups
      }
    }
  }
  </script>
  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
  